var TYPE = "PROJECT_CHANGED";
export var isProjectChangedMessage = function isProjectChangedMessage(m) {
  return (m === null || m === void 0 ? void 0 : m.type) === TYPE;
};
export var projectChangedMessage = function projectChangedMessage(_ref) {
  var fromProjectId = _ref.from.projectId,
    toProjectId = _ref.to.projectId;
  return {
    type: TYPE,
    payload: {
      from: {
        projectId: fromProjectId
      },
      to: {
        projectId: toProjectId
      }
    }
  };
};